// variável do forms api
let isInit = false;
let gisInited = false;
let gapiInited = false;
let tokenClient;
let urlDoSevico;

function getUrlForService(servico) {
    let url;
    switch (servico) {
        case 'forms':
            url = 'https://forms.googleapis.com/$discovery/rest?version=v1';
            break;
        case 'docs':
            url = 'https://docs.googleapis.com/$discovery/rest?version=v1';
            break;
        case 'slides':
            url = 'https://slides.googleapis.com/$discovery/rest?version=v1';
            break;
        default:
            url = 'Unknown service';
            break;
    }
    return url;
}


// Função para adicionar o script dinamicamente
const loadScript = (id, src, onLoad) => {
    if (document.getElementById(id)) {
        return; // Script já adicionado
    }
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = onLoad;
    document.head.appendChild(script);
};

// Função para remover o script (opcional)
const removeScript = (id) => {
    const script = document.getElementById(id);
    if (script) {
        document.head.removeChild(script);
    }
};
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Funções específicas para carregar e remover os scripts do Google
const loadGoogleScripts = (servico) => {
    loadScript('google-api', 'https://apis.google.com/js/api.js', () => {
        console.log('Google API script carregado');
        urlDoSevico = getUrlForService(servico)
        gapiLoad()
    });
    loadScript('google-gis', 'https://accounts.google.com/gsi/client', () => {
        console.log('Google Identity Services script carregado');
        gisInit()
    });
};

const unloadGoogleScripts = () => {
    removeScript('google-api');
    removeScript('google-gis');
};


function checkBeforeStart() {
    if (gapiInited && gisInited) {
        // Start only when both gapi and gis are initialized.
        isInit = true;
    }
}

function gisInit() {

    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: '758705817118-7miqlg8frcimb74s2kn0utciecf8sls2.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/drive.file',
        callback: '',
    });
    gisInited = true;
    checkBeforeStart();
}

function gapiInit() {
    gapi.client.init({

    })
        .then(function () {
            gapi.client.load(urlDoSevico);
            gapiInited = true;
            checkBeforeStart();
        });
}

function gapiLoad() {
    gapi.load('client', gapiInit);
}


async function gapiInitServico(servico) {
    servico = getUrlForService(servico);
    gapi.client.init({

    })
        .then(function () {
            gapi.client.load(servico);
            gapiInited = true;
            checkBeforeStart();
        });
}



// funções padrão para incializar função de autenticação
function googleAuth() {
    return new Promise((resolve, reject) => {
        tokenClient.callback = (resp) => {
            if (resp.error !== undefined) {
                reject(resp);
            }
            resolve(true);
        }

        if (gapi.client.getToken() === null) {

            tokenClient.requestAccessToken({ prompt: 'consent' });
        } else {
            tokenClient.requestAccessToken({ prompt: '' });
            resolve(true);
        }
    });
}


export { googleAuth, loadGoogleScripts, unloadGoogleScripts, gapiInitServico }